import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import validationEngine from 'devextreme/ui/validation_engine';
import { PurchaseOrderLine } from 'src/app/core/data/entities';
import { environment } from 'src/environments/environment';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-purchase-order-line-dialog',
    templateUrl: './purchase-order-line-dialog.component.html',
    styleUrls: ['./purchase-order-line-dialog.component.scss'],
    standalone: false
})
export class PurchaseOrderLineDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    purchaseOrderLine: any;
    purchaseOrderLineAttachments: any;
    uploadUrl: string;
    jobId: number;
    activeJobs: any;
    isJobDisabled: boolean;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';
    vendors: any;

    constructor(public modalRef: BsModalRef, private uow: RAFUnitOfWork, private appInfo: AppInformationService, private auth: AuthenticationService) {}

    async ngOnInit() {
        const vendors = await this.uow.getVendors();
        this.vendors = vendors.map((x) => {
            return x.vendor;
        });
        this.vendors = _.uniq(this.vendors);

        if (this.purchaseOrderLine == null) {
            this.purchaseOrderLine = this.uow.purchaseOrderLines.createEntity() as PurchaseOrderLine;
            this.purchaseOrderLine.created = new Date();
            this.purchaseOrderLine.createdById = this.auth.userValue.id;
            this.purchaseOrderLine.jobId = this.jobId;
            this.purchaseOrderLine.invoiceDate = new Date();
        }

        this.activeJobs = await this.uow.getActiveJobs();
        if (this.purchaseOrderLine.id > 0) {
            await this.getAttachments()
            this.uploadUrl = environment.apiUrl + '/api/files/UploadPurchaseOrderAttachments?purchaseOrderId=' + this.purchaseOrderLine.id;
        }
    }

    async getAttachments() {
        const attachments = await this.uow.getPurchaseOrderLineAttachments(this.purchaseOrderLine.id);
        if (attachments) {
            this.purchaseOrderLineAttachments = _(attachments).orderBy('name').valueOf();
        }
    }

    async save(andClose?: boolean) {
        const success = await Promise.resolve(this.validate());
        if (!success) return;
        await this.uow.commit();
        this.uploadUrl = environment.apiUrl + '/api/files/UploadPurchaseOrderAttachments?purchaseOrderId=' + this.purchaseOrderLine.id;
        if (andClose) this.result.next({ success: true });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }

    async uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
    }

    uploaded(e) {
        if (e && e.request && e.request.responseText) {
            const fileResponses = JSON.parse(e.request.responseText);
            console.log('responses', fileResponses);
            for (let idx = 0; idx < fileResponses.length; idx++) {
            }
            this.getAttachments();
        }
        this.appInfo.pleaseWaitHide();
    }

    async uploadError(e) {
        this.appInfo.pleaseWaitHide();
        await alert('An error occurred while attempting to upload the file(s)', `${this.appInfo.settings.company}`);
    }

    openAttachment(attachment) {
        window.open(attachment.fileName, '_blank');
    }

    async removeAttachment(e, attachment) {
        e.preventDefault();
        attachment.deleted = new Date();
        await this.uow.commit();
        await this.getAttachments();
    }
}
